
import { Getter, State } from 'vuex-class';
import PageTop from '@/components/shared/PageTop.vue';
import SaveToolbar from '@/components/shared/SaveToolbar.vue';
import { Component, Vue } from 'vue-property-decorator';
import { SaveProvider, SaveResult } from '@/types';
import SelectInput from '@/components/shared/SelectInput.vue';
import UserProfile from '@/components/administration/UserProfile.vue';
import SideNavProfile from '@/components/administration/side-nav/SideNavProfile.vue';
import { UserDetails } from '@/store/userAccounts/types';

@Component({
  components: {
    PageTop,
    SaveToolbar,
    UserProfile,
    SideNavProfile
  }
})
export default class ProfilePage extends Vue {

}
